import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  headerData: {},
  language: "en",
  refreshList: false,
  networkIssue: false,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setAppLanguage: (state, action) => {
      state.language = action.payload;
    },
    addAppData: (state, action) => {
      const { name, data } = action.payload;
      state[name] = data;
    },
    addHeaderData: (state, action) => {
      const { name, data } = action.payload;
      state[name] = data;
    },
    isRefreshList: (state, action) => {
      state.refreshList = action.payload;
    },
    setNetworkIssue: (state, action) => {
      state.networkIssue = action.payload;
    },
  },
});

export default appSlice;
export const { setAppLanguage, addAppData, isRefreshList, setNetworkIssue } =
  appSlice.actions;
